import { render, staticRenderFns } from "./TeachingGroup.vue?vue&type=template&id=5697281f&scoped=true"
import script from "./TeachingGroup.vue?vue&type=script&lang=js"
export * from "./TeachingGroup.vue?vue&type=script&lang=js"
import style0 from "./TeachingGroup.vue?vue&type=style&index=0&id=5697281f&prod&scoped=true&lang=css"
import style1 from "./TeachingGroup.vue?vue&type=style&index=1&id=5697281f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697281f",
  null
  
)

export default component.exports